'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _headerState = require('../components/headerState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  bindUIActions();
};

var bindUIActions = function bindUIActions() {
  var $navDropdownTrigger = $(_dom2.default.navDropdownTrigger);
  var $headerNav = $(_dom2.default.headerNav);
  var $siteSearchContainer = $(_dom2.default.siteSearchContainer);
  var $siteSearch = $(_dom2.default.siteSearch);

  //Dropdown Display
  $navDropdownTrigger.on('mouseenter', function () {
    var $current = $(this);

    $headerNav.addClass('is-active');
    $navDropdownTrigger.removeClass('is-active');
    $current.addClass('is-active');

    if ($current.attr('data-nav-dropdown-trigger') != undefined) {
      (0, _headerState.headerState)('active');
    } else {
      (0, _headerState.headerState)('inactive');
    }
  });

  //Dropdown hide unless hovering through search area
  $navDropdownTrigger.on('mouseleave', function () {
    var $current = $(this);

    if (!$siteSearchContainer.is(':hover')) {
      $headerNav.removeClass('is-active');
      $current.removeClass('is-active');

      if ($siteSearch.val() === '') {
        (0, _headerState.headerState)('inactive');
      }
    }
  });

  $siteSearchContainer.on('mouseleave', function () {
    if ($headerNav.hasClass('is-active')) {
      $headerNav.removeClass('is-active');
      $navDropdownTrigger.removeClass('is-active');

      if ($siteSearch.val() === '') {
        (0, _headerState.headerState)('inactive');
      }
    }
  });
};